import { useEffect, useState } from "react";

const SelectMultiple = ({
  option,
  onChange,
  value = [],
  totalPage,
  page,
  onPage,
  onKeypress,
  loading,
  name,
  invalid = false,
  placeholder = "",
  disabled = false
}) => {
  const [isFocused, setFocused] = useState(false);
  const [oneTime, setOneTime] = useState(true);
  const [hover, setHover] = useState(null);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (oneTime) {
      setOneTime(false);
    }
  }, [oneTime, value]);
  return (
    <>
      {isFocused ? (
        <div
          style={{
            position: "fixed",
            width: "100vw",
            height: "100vh",
            top: 0,
            left: 0,
            zIndex: 1,
          }}
          onClick={() => setFocused(false)}
        />
      ) : null}
      <div className="input-group">
        <input
          name={name}
          className={`form-control ${invalid ? "is-invalid" : ""}`}
          placeholder={placeholder}
          onFocus={() => !!!disabled?setFocused(true):null}
          value={inputValue}
          onChange={(e) => {
            onKeypress(e.currentTarget.value);
            setInputValue(e.currentTarget.value);
            onChange(null);
            onPage({ ...page, of: 1 });
          }}
          autoComplete="off"
          disabled={disabled}
        />

        <div className="input-group-append">
          <span className="input-group-text">
            <i className="fa fa-solid fa-caret-down"></i>
          </span>
        </div>
      </div>
      <div style={{ position: "relative" }}>
        {isFocused ? (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: 300,
              border: "solid 1px #000",
              zIndex: "1",
            }}
          >
            {!!!loading ? (
              option.map((item, key) => (
                <div
                  key={key}
                  onMouseEnter={() => setHover(key)}
                  style={{
                    background:
                      hover === key ||
                      value.findIndex((sub) => sub.value === item.value) >= 0
                        ? "blue"
                        : "white",
                    width: "100%",
                    minHeight: "24px",
                    cursor: "pointer",
                    position: "relative",
                    borderBottom: "solid 1px #ccc",
                  }}
                  onMouseOut={() => setHover(null)}
                  onClick={() => {
                    if(value.findIndex((sub) => sub.value === item.value) >= 0){
                      onChange([...value].filter((s)=>s.value!==item.value), item);
                    }
                    else{
                      onChange([...value, item], item);
                    }
                    setInputValue("");
                    setFocused(false);
                  }}
                >
                  {item.label}
                </div>
              ))
            ) : (
              <div style={{ width: "100%", background: "#fff" }}>
                <i className="fa fa-circle-o-notch fa-spin"></i>
              </div>
            )}
            {!!page && !!onPage && !!totalPage ? (
              <div
                style={{
                  background: "white",
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <button
                  type="button"
                  onClick={() =>
                    page.of > 1 ? onPage({ ...page, of: page.of - 1 }) : null
                  }
                >
                  &lt;
                </button>
                {page.of}/{totalPage}
                <button
                  type="button"
                  onClick={() =>
                    page.of < totalPage
                      ? onPage({ ...page, of: page.of + 1 })
                      : null
                  }
                >
                  &gt;
                </button>
              </div>
            ) : null}
          </div>
        ) : null}
      </div>
    </>
  );
};

export default SelectMultiple;
